var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryAnalytics16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Analytics_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Analytics_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Analytics_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Analytics_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/Analytics_16",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001883,4.533 L12.0001883,7 L11.0001883,7 L11.0001883,5.833 L8.34518834,8.362 C8.14818834,8.549 7.83918834,8.546 7.64618834,8.353 L6.50018834,7.207 L4.35418834,9.353 L3.64618834,8.646 L6.14618834,6.146 C6.34218834,5.951 6.65818834,5.951 6.85418834,6.146 L8.00918834,7.301 L10.3911883,5 L9.00018834,5 L9.00018834,4 L11.5001883,4 C11.7761883,4 12.0001883,4.257 12.0001883,4.533 L12.0001883,4.533 Z M14.1401883,14 L1.86018834,14 L1.19418834,12 L14.8061883,12 L14.1401883,14 Z M2.00018834,2.452 C2.00018834,2.207 2.16418834,2 2.35718834,2 L13.6431883,2 C13.8361883,2 14.0001883,2.207 14.0001883,2.452 L14.0001883,11 L2.00018834,11 L2.00018834,2.452 Z M15.9051883,11.207 C15.8121883,11.077 15.6611883,11 15.5001883,11 L15.0001883,11 L15.0001883,2.452 C15.0001883,1.651 14.3911883,1 13.6431883,1 L2.35718834,1 C1.60918834,1 1.00018834,1.651 1.00018834,2.452 L1.00018834,11 L0.500188342,11 C0.339188342,11 0.188188342,11.077 0.095188342,11.207 C0.000188342023,11.338 -0.024811658,11.506 0.025188342,11.658 L1.02518834,14.655 C1.09418834,14.859 1.28518834,14.996 1.50018834,14.996 L14.5001883,14.996 C14.7151883,14.996 14.9061883,14.859 14.9751883,14.655 L15.9751883,11.658 C16.0251883,11.506 16.0001883,11.338 15.9051883,11.207 L15.9051883,11.207 Z",
    id: "Analytics_Category-Icon_64_Squid-"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryAnalytics16);
export default __webpack_public_path__ + "static/media/Arch-Category_Analytics_16.8fe3c9cdf76eaded51c3375456051a17.svg";
export { ForwardRef as ReactComponent };